module.exports = __webpack_public_path__ + "static/media/payments.e37d451a.png";